/** Shared field surface for MUI inputs and button-based date controls. */
export const formControlStyles = {
  height: "var(--form-control-height)",
  borderRadius: "var(--form-control-radius)",
  backgroundColor: "var(--form-control-bg)",
  color: "var(--foreground)",
  fontSize: "0.875rem",
  lineHeight: 1.5,
  transition:
    "border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease",
  "&:hover": { backgroundColor: "var(--form-control-hover-bg)" },
} as const;

export const dateControlStyles = {
  ...formControlStyles,
  border: "1px solid var(--form-control-border)",
  padding: "0 0.875rem",
  fontWeight: 400,
  "&:hover": {
    backgroundColor: "var(--form-control-hover-bg)",
    borderColor: "var(--form-control-hover-border)",
  },
  "&:focus-visible, &[aria-expanded='true']": {
    borderColor: "var(--primary)",
    boxShadow: "var(--form-control-focus-ring)",
    outline: "none",
  },
} as const;
